import cn from 'classnames';
import { isMobileLayout } from 'components/Shared/responsive';
import { useSelector } from 'react-redux';
import styles from './houseLinks.scss';
import { Icon } from 'views/KnowledgebasePage/Icons';
import { IconProps } from 'components/Shared/Icon';
import { KnowledgebaseMenuItem } from 'models/KnowledgebaseMenuItem';
import { NO_ELEMENT } from 'utils';

interface HouseLinksProps {
  items?: KnowledgebaseMenuItem[];
  appearance?: 'primary' | 'secondary' | 'tertiary';
}

interface LinkProps {
  url: string;
  name: string;
  menuHeader: string;
  icon: string;
  appearance?: string;
}

const Link = ({ url, name, menuHeader, icon, appearance }: LinkProps) => {
  const isMobile = useSelector(isMobileLayout);
  const iconSize = appearance === 'primary' ? 'mega' : 'xl2';
  const title = menuHeader?.length > 0 ? menuHeader : name;

  const iconProps: IconProps = {
    size: isMobile ? 'xl' : iconSize,
    className: styles.icon
  };

  return (
    <a href={url} className={styles.link}>
      <span className={cn(styles.text, { [styles.text_tertiary]: appearance === 'tertiary' })}>
        {title}
      </span>
      <Icon name={icon} props={iconProps} />
    </a>
  );
};

export const HouseLinks = ({ items, appearance = 'primary' }: HouseLinksProps) => {
  if (items === undefined || items.length === 0) {
    return NO_ELEMENT;
  }
  return (
    <div className={cn(styles.houseLinks, { [styles.secondary]: appearance === 'secondary' })}>
      {items.map(item => (
        <Link key={item.url} {...item} appearance={appearance} />
      ))}
    </div>
  );
};
